import { link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  text,
  items[]{
    type,
    link[]{${link.fields}},
    text,
    showArrow
  }
`

export const fragment = (name = 'titleAndTextList') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
